import React, { useState } from "react";
import "./feature.css"


function Feature(props) {
    
    const [expanded, setExpanded] = useState(false)

    return(
        <div onClick={()=>setExpanded(!expanded)} style={{maxHeight:`${expanded?"300px":"50px"}`}} className="feature">
            <div className="feature-title">
                <i className="material-icons-outlined">{props.icon}</i>
                <p>{props.name}</p>
            </div>
            <div className="feature-details">
                <p>{props.details}</p>
            </div>
            <i style={{transform: `${expanded?"rotate(180deg)":"rotate(0)"}`}} onClick={()=>setExpanded(!expanded)} className="material-icons btn--feature">expand_more</i>
        </div>
    )
}

export default Feature